function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 6.5C5.82843 6.5 6.5 5.82843 6.5 5C6.5 4.17157 5.82843 3.5 5 3.5C4.17157 3.5 3.5 4.17157 3.5 5C3.5 5.82843 4.17157 6.5 5 6.5Z",
  fill: "url(#paint0_linear_5718_3229)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 13.5C5.82843 13.5 6.5 12.8284 6.5 12C6.5 11.1716 5.82843 10.5 5 10.5C4.17157 10.5 3.5 11.1716 3.5 12C3.5 12.8284 4.17157 13.5 5 13.5Z",
  fill: "url(#paint1_linear_5718_3229)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5 20.5C5.82843 20.5 6.5 19.8284 6.5 19C6.5 18.1716 5.82843 17.5 5 17.5C4.17157 17.5 3.5 18.1716 3.5 19C3.5 19.8284 4.17157 20.5 5 20.5Z",
  fill: "url(#paint2_linear_5718_3229)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19 3.5H11C10.1716 3.5 9.5 4.17157 9.5 5C9.5 5.82843 10.1716 6.5 11 6.5H19C19.8284 6.5 20.5 5.82843 20.5 5C20.5 4.17157 19.8284 3.5 19 3.5Z",
  fill: "url(#paint3_linear_5718_3229)"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19 10.5H11C10.1716 10.5 9.5 11.1716 9.5 12C9.5 12.8284 10.1716 13.5 11 13.5H19C19.8284 13.5 20.5 12.8284 20.5 12C20.5 11.1716 19.8284 10.5 19 10.5Z",
  fill: "url(#paint4_linear_5718_3229)"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19 17.5H11C10.1716 17.5 9.5 18.1716 9.5 19C9.5 19.8284 10.1716 20.5 11 20.5H19C19.8284 20.5 20.5 19.8284 20.5 19C20.5 18.1716 19.8284 17.5 19 17.5Z",
  fill: "url(#paint5_linear_5718_3229)"
});
var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_5718_3229",
  x1: 3.76471,
  y1: 3.76471,
  x2: 6.23529,
  y2: 6.41176,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5F429A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3EBBC3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_5718_3229",
  x1: 3.76471,
  y1: 10.7647,
  x2: 6.23529,
  y2: 13.4118,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5F429A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3EBBC3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_5718_3229",
  x1: 3.76471,
  y1: 17.7647,
  x2: 6.23529,
  y2: 20.4118,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5F429A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3EBBC3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_5718_3229",
  x1: 10.4706,
  y1: 3.76471,
  x2: 11.6546,
  y2: 8.41626,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5F429A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3EBBC3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_5718_3229",
  x1: 10.4706,
  y1: 10.7647,
  x2: 11.6546,
  y2: 15.4163,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5F429A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3EBBC3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_5718_3229",
  x1: 10.4706,
  y1: 17.7647,
  x2: 11.6546,
  y2: 22.4163,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5F429A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3EBBC3"
})));
function SvgListActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListActive);
export default __webpack_public_path__ + "static/media/listActive.4b8b420ceba4565cdd5aa4080d3a574a.svg";
export { ForwardRef as ReactComponent };